// ---------------------------------------------
// LEVEL 1 MODULES
// ---------------------------------------------
export const level1Modules = [
    "Dashboard",
    "Stock master",
    "Account master",
    "Transaction stock",
    "Transaction account",
    "Other forms",
    "Master reports",
    "Transaction reports",
    "Stock reports",
    "Account reports",
    "Utility"
];

// ---------------------------------------------
// LEVEL 2 MODULES
// ---------------------------------------------
export const level2Modules = {
    Stockmaster: [
        "Company master",
        "Party account master",
        "Tax structure master",
        "Designation master",
        "Department master",
        "Employee group",
        "Employee master",
        "Employee record plant wise",
        "Employee record process wise",
        "Unit master",
        "Product size master",
        "Material master",
        "Payment mode master",
        "Item rate vendor wise",
        "Plant master",
        "Process master",
        "Item category master",
        "Item group",
        "Item master",
        "Product BOM setup",
        "Item wise process",
        "Plant wise item",
        "Opening stock",
        "Process rates item wise"
    ],

    Accountmaster: [
        "Party account master",
        "Employee master",
        "Country master",
        "State master",
        "City master",
        "Account group",
        "Account head master",
        "General account head",
        "Bank master",
        "Cheque book master",
        "TDS group master"
    ],

    Transactionstock: [
        "WO order receive",
        "Material planning",
        "Calculate planning data",
        "MRS register",
        "Purchasing inquiry",
        "Work planning",
        "Purchase order",
        "Material purchase",
        "Material testing",
        "Material rejection",
        "Delivery challan",
        "Sales invoice",
        "Sales return",
        "Rework product",
        "Material issue",
        "Material production",
        "Issue process transaction",
        "Material job work",
        "Job work inward"
    ],

    Transactionaccount: [
        "Payment voucher",
        "Payment receive",
        "Expense ledger account",
        "General purchase",
        "Advance withdraw",
        "Add cash/advance",
        "Employee salary",
        "Salary to bank transfer",
        "Bank to bank transfer",
        "Journal voucher",
        "Credit note entry",
        "Debit note entry"
    ],

    Otherforms: [
        "Material out",
        "Material in",
        "Gate pass",
        "Disassemble transaction",
        "Manually invoice",
        "Stock transfer",
        "Employee problem",
        "Store to plant",
        "Back to store"
    ],

    Masterreports: [
        "Product BOM reports",
        "BOM setup reports",
        "BOM form",
        "Store stock report",
        "Production summary",
        "Issues process assembly summary",
        "General dashboard",
        "Production dashboard"
    ],

    Transactionreports: [
        "Item rate vender wise",
        "Vendor rate item wise",
        "Pending work order item",
        "Planning and production reports",
        "PI reports",
        "PO type",
        "Pending stock report",
        "Purchase reports",
        "Rejection reports",
        "Pending job work",
        "Material issue report",
        "Invoice related reports",
        "Return reports",
        "Labour reports",
        "TDS reports",
        "Ledger reports",
        "Issue process assembly reports",
        "Material out transaction"
    ],

    Stockreports: [
        "Stock register",
        "Stock adjustment",
        "Item wise stock detail report",
        "Min/max stock register level",
        "Item group detail report",
        "Account stock report",
        "Item group stock category wise details report",
        "User reports",
        "General purchase register",
        "Sales general register"
    ],

    Accountreports: [
        "Ledger report",
        "Profit-loss report",
        "Balance sheet"
    ],

    Utility: [
        "Admin Permissions",
        "HOD Permissions",
        "User Permissions"
    ]
};

// ---------------------------------------------
// LEVEL 3 MODULES
// ---------------------------------------------
export const level3Modules = {
    Pendingworkorderitem: [
        "Pending WO report",
        "Pending WO report customer wise",
        "Only pending item wise",
        "WO pending item wise",
        "WO pending group wise"
    ],

    Planningandproductionreports: [
        "Work order production pending",
        "Production pending item wise",
        "Material planning pending report",
        "Material planning report"
    ],

    PIreports: [
        "All transaction",
        "Pending transaction",
        "Pending transaction category wise",
        "Item wise transaction"
    ],

    Pendingstockreport: [
        "All transaction",
        " Vendor wise",
        "Only pending transaction",
        "Item group wise puechase pending"
    ],

    Purchasereports: [
        "Purchase summary",
        "Party wise purchase summary",
        "Purchase item wise",
        "Purchase item group wise",
        "Purchase summary item and party wise",
        "Supplier purchase summary",
        "Supplier evaluation report"
    ],

    Rejectionreports: [
        "Rejection pending details",
        "Item wise pending rejection",
        "Item group pending rejection",
        "Party wise pending rejection",
        "Material issue process rejection",
        "Inward material rejection list"
    ],

    Pendingjobwork: [
        "All transaction",
        "Party wise",
        "Item wise rejection list"
    ],

    Materialissuereport: [
        "Total material issue pending",
        "Item group wise issue pending",
        "Item category wise issue pending",
        "Total material issue complete",
        "Item group wise issue complete",
        "Item category wise issue complete"
    ],

    Invoicerelatedreports: [
        "Sales invoice",
        "Sales invoice item(All)",
        "Sales invoice item wise(All)",
        "Sales invoice customer(All)",
        "Sales invoice customer wise",
        "Sales record item group wise",
        "Sales invoice tac summary",
        "Sales HSN summary",
        "Sales customer and item summary"
    ],

    Returnreports: [
        "Sales return summary",
        "Sales return customer wise",
        "Sales return item wise",
        "Sales return category wise",
        "Sales return group wise"
    ],

    Labourreports: [
        "Employee expense details report",
        "Labour Employee work calculation",
        "Labour employee work calculation date wise"
    ],

    TDSreports: [
        "TDS summary report",
        "TDS group wise report"
    ],

    Ledgerreports: [
        "Vendor ledger report",
        "Vendor payment ledger",
        "Customer ledger report",
        "Bank statement",
        "Employee expense ledger",
        "Employee advance ledger",
        "Expense head ledger",
        "Account head ledger",
        "Item ledger report",
        "Rejection ledger account",
        "JW out ledger"
    ],

    Issueprocessassemblyreports: [
        "Total assemble pending",
        "Item group wise assembly pending",
        "Item category wise assembly pending",
        "Total assembly complete",
        "Item group wise assembly complete",
        "Item category wise assembly complete",
        "Process wise pending tobular"
    ]
};
